import styled, { css } from 'styled-components';
import { FontAddiFamilyPrimaryName, FontAddiWeightBold, FontAddiWeightRegular, } from '@addi/foundation/dist/web/fonts';
import { ColorAddiCompFiveDarken5, ColorAddiCompFourAccentLighten2, } from '@addi/foundation/dist/web/colors';
import { SizeAddiFontXxSmall, SizeAddiFontXxxSmall } from '@addi/foundation/dist/web/sizes';
import { Paragraph } from '../typographies';
const containerButtonBase = css `
  background-color: ${ColorAddiCompFourAccentLighten2};
  position: absolute;
  border-radius: 24px;
  display: flex;
  cursor: pointer;
`;
export const ContainerCupoWidget = styled.div `
  ${containerButtonBase};
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  padding: 0;

  width: 211px;
  height: 45px;
  z-index: 1;
  right: 10px;
  position: fixed;
  bottom: 20px;
  box-shadow: 0 0 30px rgb(0 0 0 / 30%);

  :hover {
    background: #f4a291;
    color: ${ColorAddiCompFiveDarken5};
  }
`;
export const CupoHeaderContainer = styled.div `
  flex-direction: column;
  padding: 8px 22px 8px 12px;
`;
export const TextCupo = styled(Paragraph) `
  margin: 0;
  line-height: 23.68px;
  font-weight: ${FontAddiWeightBold};
  font-family: ${FontAddiFamilyPrimaryName};
`;
export const TitleCupo = styled(Paragraph) `
  margin: 0;
  line-height: 12.1px;
  font-weight: ${FontAddiWeightBold};
  font-size: ${SizeAddiFontXxxSmall};
`;
export const SubtitleCupo = styled(Paragraph) `
  margin: 0;
  line-height: 16.32px;
  font-weight: ${FontAddiWeightRegular};
  font-size: ${SizeAddiFontXxSmall};
`;
export const ImageIcon = styled.img `
  width: 30px;
  max-width: 100%;
`;
//# sourceMappingURL=cupo-button-widget.styled.js.map